import { render, staticRenderFns } from "./RespImg.vue?vue&type=template&id=60225be9&lang=pug&"
import script from "./RespImg.vue?vue&type=script&lang=js&"
export * from "./RespImg.vue?vue&type=script&lang=js&"
import style0 from "./RespImg.vue?vue&type=style&index=0&id=60225be9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports